import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {
  isSourceFailed,
  isSourceReady,
  progressLabel,
  progressPercent,
  unitNoun,
} from './sourceStatus';

const SourceProcessingStatus = ({ source }) => {
  if (!source?.processingStatus) return null;

  if (isSourceFailed(source)) {
    return (
      <Box display='flex' alignItems='center' gap={0.5}>
        <ErrorOutlineIcon sx={{ fontSize: 14, color: 'error.main' }} />
        <Typography variant='caption' color='error' sx={{ lineHeight: 1.3 }}>
          Failed to process
        </Typography>
      </Box>
    );
  }

  if (isSourceReady(source)) {
    const count = source.processedPartCount;
    const noun = unitNoun(source, count);
    const suffix = Number.isFinite(count) && count > 0 && noun ? ` · ${count} ${noun}` : '';
    return (
      <Typography variant='caption' color='success.main' sx={{ display: 'block', lineHeight: 1.3 }}>
        Processed{suffix}
      </Typography>
    );
  }

  const percent = progressPercent(source);

  return (
    <Box>
      <Typography variant='caption' color='text.secondary' sx={{ display: 'block', lineHeight: 1.3 }}>
        {progressLabel(source)}
      </Typography>
      <LinearProgress
        variant={percent === null ? 'indeterminate' : 'determinate'}
        value={percent === null ? undefined : percent}
        sx={{ mt: 0.5, height: 3, borderRadius: 999 }}
      />
    </Box>
  );
};

export default SourceProcessingStatus;
